import script from "./UpdateAppDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateAppDialog.vue?vue&type=script&setup=true&lang=js"

import "./UpdateAppDialog.vue?vue&type=style&index=0&id=07601ac4&lang=less"

const __exports__ = script;

export default __exports__